import gql from "graphql-tag";

export const createCaisyUser = gql`
  mutation createCaisyUser($email: String!) {
    createCaisyUser(email: $email) {
      userId
    }
  }
`;
